import React, { useContext, useEffect, useRef, useState } from 'react'
import PageTitle from '../../Components/PageTitle'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { NavLink, useLocation } from 'react-router-dom'
import { currentDateAndTime, decodeData, emailBoxCheatCode, } from '../../Constants/constants'
import Swal from 'sweetalert2'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import copy from 'clipboard-copy';
import { SubmitButton } from '../../Components/InputElements';
import Select from "react-select";

function useQuery () {
  return new URLSearchParams(useLocation().search)
}

const SentEmails = (props) => {
  const query = useQuery()
  const mail_id = query.get('id');
  const { apiURL, apiHeaderFile, apiHeaderJSON, permissions } = useContext(ConfigContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedData = queryParams.get("abs");
  const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
  
  const [loading, setLoading] = useState(false);
  const [viewEmailTemplate, setViewEmailTemplate] = useState(false);
  const [empOptions, setEmpOptions] = useState([]);
  const [emailOptions, setEmailOptions] = useState([]);
  const [emailtemplate, setEmailtemplate] = useState({
    emailId:"",
    emailBody:"",
    emailSubject: "",
  });
  const [emailRows, setEmailRows] = useState([]);
  const [errors, setErrors] = useState({})
  const [formData, setFormData] = useState({
    mailTemplateTitle: '',
    mailTemplateId: '',
    toEmail: '',
    mailSubject: '',
    mailBody: '',
    file:null,
    fileData:null,
  });
  const toEmailHeightRef= useRef();
  const toSelectEmailRef= useRef();

  const handleInputChange = (name, value) => {
    // console.log(name, value)
    setFormData({ ...formData, [name]: value })
    setErrors({ ...errors, [name]: '' })
  }

  const  adjustHeights = () => {
    // Adjust department height
    if (toSelectEmailRef.current && toEmailHeightRef.current) {
      const deptSelectHeight = toSelectEmailRef.current.controlRef.getBoundingClientRect().height;
      toEmailHeightRef.current.style.height = `${deptSelectHeight}px`;
    }

  };

  useEffect(()=>{
    adjustHeights()
  },[formData?.notification_goes_to])

  const debounceTimerRef = useRef(null)

  const handleEditorChange = (event, editor) => {
    const mailContent = editor.getData();
    console.log(mailContent);
    // Clear the previous timeout if the user is still typing
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
  
    // Set a new timeout to call the function after 1 second
    debounceTimerRef.current = setTimeout(() => {
      setFormData(prevState => ({
        ...prevState,
        mailBody: mailContent
      }));
      // Call the content change handler
      // handleContentChange(mailContent);
    }, 1000);
  
    setErrors(prevErrors => ({
      ...prevErrors,
      mailBody: ''
    }));
  };

  const handleSelectEmailTemplate=(selectedOption)=>{
    let body="";
    let subject="";
    console.log("selectedOption?.value",selectedOption?.value);
    console.log("emailOptions",emailOptions);
    emailOptions?.forEach((val)=> {
        console.log("val?.value == selectedOption?.value",val?.value, selectedOption?.value)
        if(val?.value == selectedOption?.value){
            console.log("val?.value == selectedOption?.value",val?.value, selectedOption?.value)
            body = val?.mail_body;
            subject = val?.mail_subject;
        }
    });
    console.log("body",body,subject);
    setEmailtemplate({
        ...emailtemplate,
        emailId: selectedOption?.value,
        emailBody:body,
        emailSubject: subject,
    });
  }
  
  const getInfo = () => {
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}MailMaster/GetMailTemplate?mail_template_id=${mail_id}`, {
        headers
      })
      .then(response => {
        const { success, result } = response.data
        // console.log(response?.data)
        console.log("JSON",result[0]?.mail_body);
        if (success === true) {
          setFormData({
            mailTemplateTitle: result[0]?.mail_template_title,
            mailSubject: result[0]?.mail_subject,
            mailBody: result[0]?.mail_body,
          })
        } else {
        }
      })
  }

  const getEmployeesOptionList = (e) => {
    const headers = apiHeaderJSON;
    try {
      axios
        .get(`${apiURL}Masters/GetCompanyEmployeesList`, { headers })
        .then((response) => {
          if (response.data.success === true) {
            setEmpOptions( response.data.data );
            console.log(response.data.data);
          } else {
            setEmpOptions([]);
          }
        })
    } catch (error) {
      console.error("error", error)
    }
}

const getEmailTemplateList = async () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}MailMaster/GetMailTemplateList`, {
        params: {
          limit: 9999,
          page: 1,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log(response?.data);
        if (response.data.success === true) {
            console.log("data?.response?.data",data?.response?.data);
            const options= data?.response?.data.map((val)=> {
                return { value: val?.mail_template_id, 
                    label: val?.mail_template_title,
                    mail_body: val?.mail_body,
                    mail_subject: val?.mail_subject,
                 }
            })
            console.log(options);
            setEmailOptions(options);
            setEmailRows(data?.response?.data);
        } else {
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  useEffect(() => {
    if (mail_id) {
      getInfo();
    }
    getEmployeesOptionList();
    getEmailTemplateList();
  }, []);

  const handleSubmit = e => {
    e.preventDefault()

    const errors = validateForm()
    console.error('Create Mail Error', errors)
    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      return
    }
    setLoading(true)
    const data = {
      mail_template_id: formData?.mailTemplateId || null,
      email_body: formData?.mailBody || null,
      email_to: formData?.toEmail || null,
      email_subject: formData?.mailSubject || null,
      date: currentDateAndTime() || null,
    }
    if(formData?.file){
        data.file = formData?.file;
    }

    const headers = formData?.file? apiHeaderFile : apiHeaderJSON;
    // setLoading(true);
        //   Swal.fire({
        //     title: `<strong>Failed</strong>`,
        //     text: 'Email Send Nhi Ho Sakta, Kyunki Backend ka Kam Chal Raha Hai! Abdul Backend ka kam dekh raha hai! ',
        //     icon: 'error',
        //     showConfirmButton: true,
        //     allowOutsideClick: false,
        //   }).then(()=>{
        //     setLoading(false);
        //   })
    axios
      .post(`${apiURL}MailMaster/ComposeEmail`, data, {
        headers
      })
      .then(response => {
        const { success } = response.data
        if (success === true) {
          setFormData({
            toEmail: '',
            mailSubject: '',
            mailBody: '',
            mail_template_id: '',
            file:null,
            fileData:null,
          });
          
          Swal.fire({
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false
          }).then(()=>{
            handleClick();
          })
        } else {
          Swal.fire({
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false
          })
        }
        setLoading(false)
      })
      .catch(error => {
        Swal.fire({
          title: `<strong>"Failed"</strong>`,
          text: error?.data?.message,
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        })
        setLoading(false)
      })
  }
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const errors={};
    console.log(file);
    if (file) {
      console.log(file.size);
        const { name, size, type } = file;
        console.log("type",type);
        const fileSizeInMB = size / (1024 * 1024);
        console.log("size",size / (1024 * 1024));
        errors.required_document = '';
        if (fileSizeInMB > 10) {
            errors.file= "File size exceeds the maximum limit of 10 MB";
            setErrors({
                ...errors,
                file:"File size exceeds the maximum limit of 10 MB"
            });
            console.error("File size exceeds the maximum limit of 10 MB");
            return;
        }
        let newState = {
            fileName: name,
            fileSize: `${fileSizeInMB.toFixed(2)} MB`,
            letterhead: [file],
            errorMessage: errors?.file,
            fileDelete:true
        };

        if (type.startsWith("image/")) {
            newState = {
                ...newState,
                selectedImage: URL.createObjectURL(file),
                fileTypeIcon: "/assets/img-logo.png",
            };
        }
        else if(name.includes(".xlsx")){
            newState = {
                ...newState,
                selectedImage: URL.createObjectURL(file),
                fileTypeIcon: "/assets/excel-icon.png",
            };
        }
         else {
            newState = {
                ...newState,
                isValidPdfFile: true,
                fileTypeIcon: "/assets/pdf-logo.svg",
            };
        }
        console.log(file,newState,);
        setErrors({
            ...errors,
            file:""
        });
        setFormData({
            ...formData,
            file:file,
            fileData:newState,
        });

    }
};
const handleDeleteImage=()=>{
    setFormData({
        ...formData,
        file:null,
        fileData:null,
    })
}
  const validateForm = () => {
    const errors = {}
    if (!formData?.toEmail) {
      errors.toEmail = 'Please select employee to send email!'
    }
    if (!formData?.mailSubject) {
      errors.mailSubject = 'Email subject is required!'
    }
    if (!formData?.mailBody) {
      errors.mailBody = 'Email Body is can not be empty!'
    }
    // console.log(formData?.mailBody);

    return errors
  }

  const handleCopyClick = (code) => {
    copy(code);
    toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
  };

  const handleMultiSelect = (fieldName, selectedOptions) => {
    console.log("selectedOptions fieldName",fieldName, selectedOptions);
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setFormData(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')  
        }));
    // Clear the error message for componentLocation
    setErrors(prevErrors => ({
        ...prevErrors,
        [fieldName]: ''
    }));
};

  const handleClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };
  return (
    
        <div className=''>
              <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
                >
                <div className="offcanvas-header">
                  <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                  <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  />
                </div>

                <div className="offcanvas-body">
                  <table class="table table-hover table-bordered border-primary table-nowrap">
                    <thead className="bg-primary text-light bg-gradient">
                      <tr>
                        <th scope="col">Names</th>
                        <th scope="col">Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        emailBoxCheatCode?.map((val)=>{
                          return (
                            <tr>
                                <td>{val?.name}</td>
                                <td onClick={() => handleCopyClick(val?.code)} style={{ cursor: "pointer" }}>{val?.code}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
          <div className='card'>
            <div className='card-header align-items-center d-flex'>
              <h4 className='card-title mb-0 flex-grow-1'>
                {/* {company_salary_head_id ? "Update Payroll Head" : "Create Payroll Head"} */}
                {'Compose Email'}
              </h4>
              <div className=' d-flex align-items-center gap-2'>
              <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light btn-label"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRight"
                  aria-controls="offcanvasRight"
                >
                  <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                  Placeholder Keys
                </button>
                <SubmitButton disabled={loading} onClick={()=>{ 
                    setViewEmailTemplate(true);
                    setEmailtemplate({
                        ...emailtemplate,
                        emailId: "",
                        emailBody: "",
                        emailSubject: "",
                    });
                 }} buttonName={'Email templates'} icon={'ri-mail-line'} 
                type='info' iconSide='left' float='right' />
                <SubmitButton disabled={loading} onClick={()=>{ handleClick() }} buttonName={'Back'} icon={'ri-arrow-left-circle-line'} 
                type='success' iconSide='left' float='right' />
              </div>
            </div>
            <div className='card-body'>
              <form>
                <div className="">
                    <div className='row'>
                        <div ref={toEmailHeightRef} className='col-md-12 mb-5 position-relative'>
                            <label htmlFor='toEmail' className='form-label'>
                            To:
                            </label>
                            <div style={{width:"98%"}} className=' position-absolute z-3 ' >
                                <Select
                                ref={toSelectEmailRef}
                                    // onInputChange={(e) => {setEmpkeyword(e); getEmployeesOptionList(e) }}
                                    onChange={(selectedOptions) => handleMultiSelect("toEmail", selectedOptions)}
                                    placeholder="Search & Select Employees"
                                    isMulti
                                    className={`${errors.toEmail ? "is-invalid" : ""}`}
                                    options={empOptions}
                                    value={formData?.toEmail ? formData?.toEmail.split(',').map(id => empOptions.find(option => option.value == id)) : null}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: errors?.toEmail ? "red" : base.borderColor,
                                            boxShadow: errors?.toEmail ? "0 0 0 1px red" : state.isFocused ? "0 0 0 1px blue" : base.boxShadow,
                                            "&:hover": {
                                                borderColor: errors?.toEmail ? "red" : base.borderColor,
                                            },
                                        }),
                                    }}
                                />
                                {errors.toEmail && <div className="invalid-feedback">{errors.toEmail}</div>} 
                            </div>         
                        </div>
                        <div className='col-md-6 mb-3 mt-0'>
                            <label htmlFor='mailSubject' className='form-label'>
                            Subject:
                            </label>
                            <input
                            type='text'
                            id='mailSubject'
                            name='mailSubject'
                            value={formData?.mailSubject}
                            onChange={e =>
                                handleInputChange('mailSubject', e.target.value)
                            }
                            className={`form-control  ${
                                errors.mailSubject ? 'is-invalid' : ''
                            }`}
                            placeholder='Enter Subject'
                            />

                            {errors.mailSubject && (
                            <div className='invalid-feedback'>
                                {errors.mailSubject}
                            </div>
                            )}
                        </div>
                        <div className='col-md-6 mb-3 mt-0'>             
                            <label className="form-label">Attachment <span className='text-muted '>(...Optional)</span></label>
                            <div>
                                <input
                                    type="file"
                                    id="employee_resignation_document"
                                    
                                    onChange={handleFileChange}
                                    style={{ display: "none" }}
                                    // accept="image/jpeg, image/png, application/pdf"
                                    // disabled={check_modal_type === 2}
                                />
                                {!formData.file && (
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <label
                                                type="submit"
                                                className="btn btn-primary btn-label waves-effect waves-light"
                                                style={{ }}
                                                htmlFor="employee_resignation_document"
                                                // disabled={check_modal_type === 2}
                                            >
                                                <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                                Choose File
                                            </label>
                                            {errors.file && <div className="text-danger">{errors.file}</div>}
                                        </div>
                                    </div>
                                )}
                                    
                                <input
                                    type="file"
                                    id="employee_resignation_document"
                                    
                                    onChange={handleFileChange}
                                    style={{  display: "none" }}
                                    // accept="image/jpeg, image/png, application/pdf"
                                />
                                <ul
                                    className="list-unstyled mb-0"
                                    id="dropzone-preview"
                                    style={{ display: !formData.file ? "none" : "block", }}>
                                    <li className="dz-processing dz-error dz-complete"
                                        id="dropzone-preview-list">
                                        <div className="border rounded px-2 py-1">
                                            <div className="d-flex align-items-center gap-2">
                                                {/* <div className={`flex-shrink-0 me-3`}> */}
                                                    <div className=" bg-light rounded p-1 d-flex align-items-center justify-content-center">
                                                        {/* <i className={formData.fileData?.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i> */}
                                                        <img style={{ width:"25px"}} src={formData.fileData?.fileTypeIcon} alt="pdf" />
                                                    </div>
                                                {/* </div> */}
                                                <div className="flex-grow-1">
                                                    <div className="pt-1">
                                                        <h5
                                                            className="fs-13 mb-1"
                                                            data-dz-name=""
                                                        >
                                                            {formData.fileData?.fileName}
                                                        </h5>
                                                        {/* <p
                                                            className="fs-13 text-muted mb-0"
                                                            data-dz-size=""
                                                        >
                                                            <strong>{formData.fileData?.fileSize}</strong>
                                                        </p> */}
                                                    </div>
                                                </div>
                                                <div className="flex-shrink-0 ms-2 d-flex justify-content-center align-items-center">
                                                    <button
                                                        type='button'
                                                        data-dz-remove=""
                                                        onClick={handleDeleteImage}
                                                        className="btn btn-sm btn-outline-danger"
                                                    >
                                                        <i className="ri-delete-bin-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div> 
                        </div>
                    </div>
                </div>
                <div className='col-md-12'>
                  <CKEditor
                    editor={ClassicEditor}
                    data={formData?.mailBody}
                    name={'mailBody'}
                    onChange={handleEditorChange}
                  />
                  {errors.mailBody && (
                    <div style={{ fontSize: '12px' }} className=' text-danger'>
                      {errors.mailBody}
                    </div>
                  )}
                  { decodedData?.includes(3) && ( 
                  <div style={{ marginTop: '30px', marginLeft: 'Auto' }}>
                    <SubmitButton onClick={(e)=>{ handleSubmit(e) }} loading={loading} 
                    loadingMessage='Please Wait' buttonName={'Send'} icon={' ri-mail-send-line'} 
                    type='primary' iconSide='left' float='right' />
                  </div>)}
                </div>
              </form>
              {viewEmailTemplate && (
                  <div
                  id="myModal"
                  className="modal show"
                  tabIndex={-1}
                  style={{
                      display: "block",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                  aria-labelledby="myModalLabel"
                  aria-hidden="true"
                  >
                  <div
                      className=" bg-light mt-4 m-auto"
                      style={{ width: "75%" }} // Custom width for the modal
                  >
                      <div className="modal-content">
                      <div className="">
                          <div
                          style={{
                              borderBottom:
                              "1px solid var(--vz-border-color)",
                          }}
                          className=" py-3 px-3 d-flex justify-content-between align-items-center"
                          >
                          <h4 className="card-title mb-0">
                              Email Templates
                          </h4>
                          <button
                              onClick={() => {
                              setViewEmailTemplate(false);
                              setEmailtemplate({
                                  ...emailtemplate,
                                  emailId: "",
                                  emailBody: "",
                                  emailSubject: "",
                              });
                              }}
                              className="btn-close"
                              aria-label="Close"
                          ></button>
                          </div>
                      </div>
                      <div
                          style={{ padding: "0 10px 10px 10px" }}
                          className="modal-body"
                      >
                          <div style={{ }} className=' card-body'>
                          <div className="col-md-6 mt-3 mb-5">
                              <label htmlFor="email_template" className="form-label">
                                  Email Template
                              </label>
                                  <div style={{width:"50%"}} className=' position-absolute z-3 ' >
                                      <Select
                                          id="email_template"
                                          name="email_template"
                                          value={ emailtemplate?.emailId ? emailOptions?.find(
                                              (val) => val?.value == emailtemplate?.emailId
                                          ):null}
                                          onChange={(selectedOption) => {
                                              handleSelectEmailTemplate(selectedOption);
                                          }}
                                          options={emailOptions}
                                          placeholder="Select Template"
                                      />
                                  </div>
                          </div>
                              <CKEditor
                                  editor={ClassicEditor}
                                  data={emailtemplate?.emailBody}
                                  name={'mailBody'}
                                  // onChange={handleEditorChange}
                                  disabled
                              />
                              <div className=" d-flex align-items-center gap-2 mt-3">
                                  <SubmitButton disabled={!emailtemplate?.emailBody} onClick={()=>{ 
                                      setFormData({
                                          ...formData,
                                          mailTemplateId: emailtemplate?.emailId,
                                          mailSubject: emailtemplate?.emailSubject,
                                          mailBody: emailtemplate?.emailBody,
                                      });
                                      setViewEmailTemplate(false);
                                  }} buttonName={'Use Template'} icon={'ri-check-line'} 
                                  type='primary' iconSide='left'/>
                                  <SubmitButton onClick={()=>{  
                                      setViewEmailTemplate(false);
                                      setEmailtemplate({
                                          ...emailtemplate,
                                          emailId: "",
                                          emailBody: "",
                                          emailSubject: "",
                                      }); }} buttonName={'Cancel'} icon={'ri-close-line'} 
                                  type='danger' iconSide='left'/>
                              </div>
                          </div>
                          
                      </div>
                      </div>
                  </div>
                  </div>)   
              }
              
            </div>
          </div>
        </div>
  )
}

export default SentEmails
